
import React from 'react'
import Loader from '../../../../../../components/Loader';
import AllDetailList from './AllDetailList';
import { useAllDetailItems } from './hooks/useAllDetailItems';

const AllDetail = ({ cardId, boardPermission }) => {
  const { isLoading, items } = useAllDetailItems(cardId);

  return (
    <>
      {isLoading ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        <AllDetailList
          cardId={cardId}
          items={items}
          boardPermission={boardPermission}
        />
      )}
    </>
  );
};

export default React.memo(AllDetail)
